import * as a from "react";
import { useLayoutEffect as Mn, useEffect as kn, useRef as ur } from "react";
import { jsx as me, jsxs as jt, Fragment as lr } from "react/jsx-runtime";
import { t as yt, i as ar } from "./index.esm-Dkuk1b-q.js";
import { r as An } from "./index-Cwrov8qI.js";
function wt() {
  return typeof window < "u";
}
function Le(e) {
  return Sn(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function pe(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ce(e) {
  var t;
  return (t = (Sn(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Sn(e) {
  return wt() ? e instanceof Node || e instanceof pe(e).Node : !1;
}
function X(e) {
  return wt() ? e instanceof Element || e instanceof pe(e).Element : !1;
}
function re(e) {
  return wt() ? e instanceof HTMLElement || e instanceof pe(e).HTMLElement : !1;
}
function _t(e) {
  return !wt() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof pe(e).ShadowRoot;
}
function tt(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = be(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function fr(e) {
  return ["table", "td", "th"].includes(Le(e));
}
function xt(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function qt(e) {
  const t = Rt(), n = X(e) ? be(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function dr(e) {
  let t = Te(e);
  for (; re(t) && !Oe(t); ) {
    if (qt(t))
      return t;
    if (xt(t))
      return null;
    t = Te(t);
  }
  return null;
}
function Rt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Oe(e) {
  return ["html", "body", "#document"].includes(Le(e));
}
function be(e) {
  return pe(e).getComputedStyle(e);
}
function Et(e) {
  return X(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Te(e) {
  if (Le(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    _t(e) && e.host || // Fallback.
    Ce(e)
  );
  return _t(t) ? t.host : t;
}
function Ln(e) {
  const t = Te(e);
  return Oe(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : re(t) && tt(t) ? t : Ln(t);
}
function ke(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Ln(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = pe(o);
  if (i) {
    const c = Vt(s);
    return t.concat(s, s.visualViewport || [], tt(o) ? o : [], c && n ? ke(c) : []);
  }
  return t.concat(o, ke(o, [], n));
}
function Vt(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Re(e) {
  let t = e.activeElement;
  for (; ((n = t) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null; ) {
    var n;
    t = t.shadowRoot.activeElement;
  }
  return t;
}
function ne(e, t) {
  if (!e || !t)
    return !1;
  const n = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && _t(n)) {
    let r = t;
    for (; r; ) {
      if (e === r)
        return !0;
      r = r.parentNode || r.host;
    }
  }
  return !1;
}
function Dn() {
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function Fn() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: r
    } = t;
    return n + "/" + r;
  }).join(" ") : navigator.userAgent;
}
function Nn(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : Kt() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function Yt(e) {
  return gr() ? !1 : !Kt() && e.width === 0 && e.height === 0 || Kt() && e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "touch";
}
function _n() {
  return /apple/i.test(navigator.vendor);
}
function Kt() {
  const e = /android/i;
  return e.test(Dn()) || e.test(Fn());
}
function mr() {
  return Dn().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function gr() {
  return Fn().includes("jsdom/");
}
function Ze(e, t) {
  const n = ["mouse", "pen"];
  return t || n.push("", void 0), n.includes(e);
}
function pr(e) {
  return "nativeEvent" in e;
}
function hr(e) {
  return e.matches("html,body");
}
function ae(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
function Pt(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const n = e;
  return n.target != null && t.contains(n.target);
}
function Ie(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
const vr = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function zt(e) {
  return re(e) && e.matches(vr);
}
function le(e) {
  e.preventDefault(), e.stopPropagation();
}
function Vn(e) {
  return e ? e.getAttribute("role") === "combobox" && zt(e) : !1;
}
const qe = Math.min, Ne = Math.max, gt = Math.round, He = Math.floor, Ee = (e) => ({
  x: e,
  y: e
}), br = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, yr = {
  start: "end",
  end: "start"
};
function Wt(e, t, n) {
  return Ne(e, qe(t, n));
}
function nt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ve(e) {
  return e.split("-")[0];
}
function rt(e) {
  return e.split("-")[1];
}
function Kn(e) {
  return e === "x" ? "y" : "x";
}
function Ut(e) {
  return e === "y" ? "height" : "width";
}
function Ye(e) {
  return ["top", "bottom"].includes(Ve(e)) ? "y" : "x";
}
function Xt(e) {
  return Kn(Ye(e));
}
function wr(e, t, n) {
  n === void 0 && (n = !1);
  const r = rt(e), o = Xt(e), i = Ut(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = pt(s)), [s, pt(s)];
}
function xr(e) {
  const t = pt(e);
  return [Bt(e), t, Bt(t)];
}
function Bt(e) {
  return e.replace(/start|end/g, (t) => yr[t]);
}
function Rr(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : s;
    default:
      return [];
  }
}
function Er(e, t, n, r) {
  const o = rt(e);
  let i = Rr(Ve(e), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(Bt)))), i;
}
function pt(e) {
  return e.replace(/left|right|bottom|top/g, (t) => br[t]);
}
function Cr(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Wn(e) {
  return typeof e != "number" ? Cr(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ht(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function on(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = Ye(t), s = Xt(t), c = Ut(s), f = Ve(t), l = i === "y", d = r.x + r.width / 2 - o.width / 2, g = r.y + r.height / 2 - o.height / 2, p = r[c] / 2 - o[c] / 2;
  let u;
  switch (f) {
    case "top":
      u = {
        x: d,
        y: r.y - o.height
      };
      break;
    case "bottom":
      u = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      u = {
        x: r.x + r.width,
        y: g
      };
      break;
    case "left":
      u = {
        x: r.x - o.width,
        y: g
      };
      break;
    default:
      u = {
        x: r.x,
        y: r.y
      };
  }
  switch (rt(t)) {
    case "start":
      u[s] -= p * (n && l ? -1 : 1);
      break;
    case "end":
      u[s] += p * (n && l ? -1 : 1);
      break;
  }
  return u;
}
const Ir = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, c = i.filter(Boolean), f = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let l = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: d,
    y: g
  } = on(l, r, f), p = r, u = {}, h = 0;
  for (let m = 0; m < c.length; m++) {
    const {
      name: x,
      fn: v
    } = c[m], {
      x: y,
      y: R,
      data: M,
      reset: A
    } = await v({
      x: d,
      y: g,
      initialPlacement: r,
      placement: p,
      strategy: o,
      middlewareData: u,
      rects: l,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = y ?? d, g = R ?? g, u = {
      ...u,
      [x]: {
        ...u[x],
        ...M
      }
    }, A && h <= 50 && (h++, typeof A == "object" && (A.placement && (p = A.placement), A.rects && (l = A.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : A.rects), {
      x: d,
      y: g
    } = on(l, p, f)), m = -1);
  }
  return {
    x: d,
    y: g,
    placement: p,
    strategy: o,
    middlewareData: u
  };
};
async function Bn(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: c,
    strategy: f
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: g = "floating",
    altBoundary: p = !1,
    padding: u = 0
  } = nt(t, e), h = Wn(u), x = c[p ? g === "floating" ? "reference" : "floating" : g], v = ht(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(x))) == null || n ? x : x.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(c.floating)),
    boundary: l,
    rootBoundary: d,
    strategy: f
  })), y = g === "floating" ? {
    x: r,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, R = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c.floating)), M = await (i.isElement == null ? void 0 : i.isElement(R)) ? await (i.getScale == null ? void 0 : i.getScale(R)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, A = ht(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: y,
    offsetParent: R,
    strategy: f
  }) : y);
  return {
    top: (v.top - A.top + h.top) / M.y,
    bottom: (A.bottom - v.bottom + h.bottom) / M.y,
    left: (v.left - A.left + h.left) / M.x,
    right: (A.right - v.right + h.right) / M.x
  };
}
const Or = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: s,
      elements: c,
      middlewareData: f
    } = t, {
      element: l,
      padding: d = 0
    } = nt(e, t) || {};
    if (l == null)
      return {};
    const g = Wn(d), p = {
      x: n,
      y: r
    }, u = Xt(o), h = Ut(u), m = await s.getDimensions(l), x = u === "y", v = x ? "top" : "left", y = x ? "bottom" : "right", R = x ? "clientHeight" : "clientWidth", M = i.reference[h] + i.reference[u] - p[u] - i.floating[h], A = p[u] - i.reference[u], N = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(l));
    let _ = N ? N[R] : 0;
    (!_ || !await (s.isElement == null ? void 0 : s.isElement(N))) && (_ = c.floating[R] || i.floating[h]);
    const Y = M / 2 - A / 2, K = _ / 2 - m[h] / 2 - 1, S = qe(g[v], K), j = qe(g[y], K), P = S, w = _ - m[h] - j, b = _ / 2 - m[h] / 2 + Y, k = Wt(P, b, w), E = !f.arrow && rt(o) != null && b !== k && i.reference[h] / 2 - (b < P ? S : j) - m[h] / 2 < 0, T = E ? b < P ? b - P : b - w : 0;
    return {
      [u]: p[u] + T,
      data: {
        [u]: k,
        centerOffset: b - k - T,
        ...E && {
          alignmentOffset: T
        }
      },
      reset: E
    };
  }
}), Tr = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: s,
        initialPlacement: c,
        platform: f,
        elements: l
      } = t, {
        mainAxis: d = !0,
        crossAxis: g = !0,
        fallbackPlacements: p,
        fallbackStrategy: u = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: m = !0,
        ...x
      } = nt(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const v = Ve(o), y = Ye(c), R = Ve(c) === c, M = await (f.isRTL == null ? void 0 : f.isRTL(l.floating)), A = p || (R || !m ? [pt(c)] : xr(c)), N = h !== "none";
      !p && N && A.push(...Er(c, m, h, M));
      const _ = [c, ...A], Y = await Bn(t, x), K = [];
      let S = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (d && K.push(Y[v]), g) {
        const b = wr(o, s, M);
        K.push(Y[b[0]], Y[b[1]]);
      }
      if (S = [...S, {
        placement: o,
        overflows: K
      }], !K.every((b) => b <= 0)) {
        var j, P;
        const b = (((j = i.flip) == null ? void 0 : j.index) || 0) + 1, k = _[b];
        if (k)
          return {
            data: {
              index: b,
              overflows: S
            },
            reset: {
              placement: k
            }
          };
        let E = (P = S.filter((T) => T.overflows[0] <= 0).sort((T, O) => T.overflows[1] - O.overflows[1])[0]) == null ? void 0 : P.placement;
        if (!E)
          switch (u) {
            case "bestFit": {
              var w;
              const T = (w = S.filter((O) => {
                if (N) {
                  const C = Ye(O.placement);
                  return C === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  C === "y";
                }
                return !0;
              }).map((O) => [O.placement, O.overflows.filter((C) => C > 0).reduce((C, I) => C + I, 0)]).sort((O, C) => O[1] - C[1])[0]) == null ? void 0 : w[0];
              T && (E = T);
              break;
            }
            case "initialPlacement":
              E = c;
              break;
          }
        if (o !== E)
          return {
            reset: {
              placement: E
            }
          };
      }
      return {};
    }
  };
};
async function Pr(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = Ve(n), c = rt(n), f = Ye(n) === "y", l = ["left", "top"].includes(s) ? -1 : 1, d = i && f ? -1 : 1, g = nt(t, e);
  let {
    mainAxis: p,
    crossAxis: u,
    alignmentAxis: h
  } = typeof g == "number" ? {
    mainAxis: g,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: g.mainAxis || 0,
    crossAxis: g.crossAxis || 0,
    alignmentAxis: g.alignmentAxis
  };
  return c && typeof h == "number" && (u = c === "end" ? h * -1 : h), f ? {
    x: u * d,
    y: p * l
  } : {
    x: p * l,
    y: u * d
  };
}
const Mr = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: s,
        middlewareData: c
      } = t, f = await Pr(t, e);
      return s === ((n = c.offset) == null ? void 0 : n.placement) && (r = c.arrow) != null && r.alignmentOffset ? {} : {
        x: o + f.x,
        y: i + f.y,
        data: {
          ...f,
          placement: s
        }
      };
    }
  };
}, kr = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: c = {
          fn: (x) => {
            let {
              x: v,
              y
            } = x;
            return {
              x: v,
              y
            };
          }
        },
        ...f
      } = nt(e, t), l = {
        x: n,
        y: r
      }, d = await Bn(t, f), g = Ye(Ve(o)), p = Kn(g);
      let u = l[p], h = l[g];
      if (i) {
        const x = p === "y" ? "top" : "left", v = p === "y" ? "bottom" : "right", y = u + d[x], R = u - d[v];
        u = Wt(y, u, R);
      }
      if (s) {
        const x = g === "y" ? "top" : "left", v = g === "y" ? "bottom" : "right", y = h + d[x], R = h - d[v];
        h = Wt(y, h, R);
      }
      const m = c.fn({
        ...t,
        [p]: u,
        [g]: h
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - r,
          enabled: {
            [p]: i,
            [g]: s
          }
        }
      };
    }
  };
};
function $n(e) {
  const t = be(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = re(e), i = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, c = gt(n) !== i || gt(r) !== s;
  return c && (n = i, r = s), {
    width: n,
    height: r,
    $: c
  };
}
function Gt(e) {
  return X(e) ? e : e.contextElement;
}
function je(e) {
  const t = Gt(e);
  if (!re(t))
    return Ee(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = $n(t);
  let s = (i ? gt(n.width) : n.width) / r, c = (i ? gt(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: s,
    y: c
  };
}
const Ar = /* @__PURE__ */ Ee(0);
function Hn(e) {
  const t = pe(e);
  return !Rt() || !t.visualViewport ? Ar : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Sr(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== pe(e) ? !1 : t;
}
function Ke(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = Gt(e);
  let s = Ee(1);
  t && (r ? X(r) && (s = je(r)) : s = je(e));
  const c = Sr(i, n, r) ? Hn(i) : Ee(0);
  let f = (o.left + c.x) / s.x, l = (o.top + c.y) / s.y, d = o.width / s.x, g = o.height / s.y;
  if (i) {
    const p = pe(i), u = r && X(r) ? pe(r) : r;
    let h = p, m = Vt(h);
    for (; m && r && u !== h; ) {
      const x = je(m), v = m.getBoundingClientRect(), y = be(m), R = v.left + (m.clientLeft + parseFloat(y.paddingLeft)) * x.x, M = v.top + (m.clientTop + parseFloat(y.paddingTop)) * x.y;
      f *= x.x, l *= x.y, d *= x.x, g *= x.y, f += R, l += M, h = pe(m), m = Vt(h);
    }
  }
  return ht({
    width: d,
    height: g,
    x: f,
    y: l
  });
}
function Jt(e, t) {
  const n = Et(e).scrollLeft;
  return t ? t.left + n : Ke(Ce(e)).left + n;
}
function jn(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), o = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Jt(e, r)
  )), i = r.top + t.scrollTop;
  return {
    x: o,
    y: i
  };
}
function Lr(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", s = Ce(r), c = t ? xt(t.floating) : !1;
  if (r === s || c && i)
    return n;
  let f = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = Ee(1);
  const d = Ee(0), g = re(r);
  if ((g || !g && !i) && ((Le(r) !== "body" || tt(s)) && (f = Et(r)), re(r))) {
    const u = Ke(r);
    l = je(r), d.x = u.x + r.clientLeft, d.y = u.y + r.clientTop;
  }
  const p = s && !g && !i ? jn(s, f, !0) : Ee(0);
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - f.scrollLeft * l.x + d.x + p.x,
    y: n.y * l.y - f.scrollTop * l.y + d.y + p.y
  };
}
function Dr(e) {
  return Array.from(e.getClientRects());
}
function Fr(e) {
  const t = Ce(e), n = Et(e), r = e.ownerDocument.body, o = Ne(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = Ne(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + Jt(e);
  const c = -n.scrollTop;
  return be(r).direction === "rtl" && (s += Ne(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: c
  };
}
function Nr(e, t) {
  const n = pe(e), r = Ce(e), o = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, c = 0, f = 0;
  if (o) {
    i = o.width, s = o.height;
    const l = Rt();
    (!l || l && t === "fixed") && (c = o.offsetLeft, f = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: c,
    y: f
  };
}
function _r(e, t) {
  const n = Ke(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = re(e) ? je(e) : Ee(1), s = e.clientWidth * i.x, c = e.clientHeight * i.y, f = o * i.x, l = r * i.y;
  return {
    width: s,
    height: c,
    x: f,
    y: l
  };
}
function sn(e, t, n) {
  let r;
  if (t === "viewport")
    r = Nr(e, n);
  else if (t === "document")
    r = Fr(Ce(e));
  else if (X(t))
    r = _r(t, n);
  else {
    const o = Hn(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return ht(r);
}
function qn(e, t) {
  const n = Te(e);
  return n === t || !X(n) || Oe(n) ? !1 : be(n).position === "fixed" || qn(n, t);
}
function Vr(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = ke(e, [], !1).filter((c) => X(c) && Le(c) !== "body"), o = null;
  const i = be(e).position === "fixed";
  let s = i ? Te(e) : e;
  for (; X(s) && !Oe(s); ) {
    const c = be(s), f = qt(s);
    !f && c.position === "fixed" && (o = null), (i ? !f && !o : !f && c.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || tt(s) && !f && qn(e, s)) ? r = r.filter((d) => d !== s) : o = c, s = Te(s);
  }
  return t.set(e, r), r;
}
function Kr(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? xt(t) ? [] : Vr(t, this._c) : [].concat(n), r], c = s[0], f = s.reduce((l, d) => {
    const g = sn(t, d, o);
    return l.top = Ne(g.top, l.top), l.right = qe(g.right, l.right), l.bottom = qe(g.bottom, l.bottom), l.left = Ne(g.left, l.left), l;
  }, sn(t, c, o));
  return {
    width: f.right - f.left,
    height: f.bottom - f.top,
    x: f.left,
    y: f.top
  };
}
function Wr(e) {
  const {
    width: t,
    height: n
  } = $n(e);
  return {
    width: t,
    height: n
  };
}
function Br(e, t, n) {
  const r = re(t), o = Ce(t), i = n === "fixed", s = Ke(e, !0, i, t);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const f = Ee(0);
  if (r || !r && !i)
    if ((Le(t) !== "body" || tt(o)) && (c = Et(t)), r) {
      const p = Ke(t, !0, i, t);
      f.x = p.x + t.clientLeft, f.y = p.y + t.clientTop;
    } else o && (f.x = Jt(o));
  const l = o && !r && !i ? jn(o, c) : Ee(0), d = s.left + c.scrollLeft - f.x - l.x, g = s.top + c.scrollTop - f.y - l.y;
  return {
    x: d,
    y: g,
    width: s.width,
    height: s.height
  };
}
function Mt(e) {
  return be(e).position === "static";
}
function cn(e, t) {
  if (!re(e) || be(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Ce(e) === n && (n = n.ownerDocument.body), n;
}
function Yn(e, t) {
  const n = pe(e);
  if (xt(e))
    return n;
  if (!re(e)) {
    let o = Te(e);
    for (; o && !Oe(o); ) {
      if (X(o) && !Mt(o))
        return o;
      o = Te(o);
    }
    return n;
  }
  let r = cn(e, t);
  for (; r && fr(r) && Mt(r); )
    r = cn(r, t);
  return r && Oe(r) && Mt(r) && !qt(r) ? n : r || dr(e) || n;
}
const $r = async function(e) {
  const t = this.getOffsetParent || Yn, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: Br(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Hr(e) {
  return be(e).direction === "rtl";
}
const jr = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Lr,
  getDocumentElement: Ce,
  getClippingRect: Kr,
  getOffsetParent: Yn,
  getElementRects: $r,
  getClientRects: Dr,
  getDimensions: Wr,
  getScale: je,
  isElement: X,
  isRTL: Hr
};
function zn(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function qr(e, t) {
  let n = null, r;
  const o = Ce(e);
  function i() {
    var c;
    clearTimeout(r), (c = n) == null || c.disconnect(), n = null;
  }
  function s(c, f) {
    c === void 0 && (c = !1), f === void 0 && (f = 1), i();
    const l = e.getBoundingClientRect(), {
      left: d,
      top: g,
      width: p,
      height: u
    } = l;
    if (c || t(), !p || !u)
      return;
    const h = He(g), m = He(o.clientWidth - (d + p)), x = He(o.clientHeight - (g + u)), v = He(d), R = {
      rootMargin: -h + "px " + -m + "px " + -x + "px " + -v + "px",
      threshold: Ne(0, qe(1, f)) || 1
    };
    let M = !0;
    function A(N) {
      const _ = N[0].intersectionRatio;
      if (_ !== f) {
        if (!M)
          return s();
        _ ? s(!1, _) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      _ === 1 && !zn(l, e.getBoundingClientRect()) && s(), M = !1;
    }
    try {
      n = new IntersectionObserver(A, {
        ...R,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(A, R);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function ko(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: f = !1
  } = r, l = Gt(e), d = o || i ? [...l ? ke(l) : [], ...ke(t)] : [];
  d.forEach((v) => {
    o && v.addEventListener("scroll", n, {
      passive: !0
    }), i && v.addEventListener("resize", n);
  });
  const g = l && c ? qr(l, n) : null;
  let p = -1, u = null;
  s && (u = new ResizeObserver((v) => {
    let [y] = v;
    y && y.target === l && u && (u.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var R;
      (R = u) == null || R.observe(t);
    })), n();
  }), l && !f && u.observe(l), u.observe(t));
  let h, m = f ? Ke(e) : null;
  f && x();
  function x() {
    const v = Ke(e);
    m && !zn(m, v) && n(), m = v, h = requestAnimationFrame(x);
  }
  return n(), () => {
    var v;
    d.forEach((y) => {
      o && y.removeEventListener("scroll", n), i && y.removeEventListener("resize", n);
    }), g == null || g(), (v = u) == null || v.disconnect(), u = null, f && cancelAnimationFrame(h);
  };
}
const Yr = Mr, zr = kr, Ur = Tr, un = Or, Xr = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: jr,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return Ir(e, t, {
    ...o,
    platform: i
  });
};
var ft = typeof document < "u" ? Mn : kn;
function vt(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!vt(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !vt(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Un(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ln(e, t) {
  const n = Un(e);
  return Math.round(t * n) / n;
}
function kt(e) {
  const t = a.useRef(e);
  return ft(() => {
    t.current = e;
  }), t;
}
function Gr(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: c = !0,
    whileElementsMounted: f,
    open: l
  } = e, [d, g] = a.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [p, u] = a.useState(r);
  vt(p, r) || u(r);
  const [h, m] = a.useState(null), [x, v] = a.useState(null), y = a.useCallback((O) => {
    O !== N.current && (N.current = O, m(O));
  }, []), R = a.useCallback((O) => {
    O !== _.current && (_.current = O, v(O));
  }, []), M = i || h, A = s || x, N = a.useRef(null), _ = a.useRef(null), Y = a.useRef(d), K = f != null, S = kt(f), j = kt(o), P = kt(l), w = a.useCallback(() => {
    if (!N.current || !_.current)
      return;
    const O = {
      placement: t,
      strategy: n,
      middleware: p
    };
    j.current && (O.platform = j.current), Xr(N.current, _.current, O).then((C) => {
      const I = {
        ...C,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: P.current !== !1
      };
      b.current && !vt(Y.current, I) && (Y.current = I, An.flushSync(() => {
        g(I);
      }));
    });
  }, [p, t, n, j, P]);
  ft(() => {
    l === !1 && Y.current.isPositioned && (Y.current.isPositioned = !1, g((O) => ({
      ...O,
      isPositioned: !1
    })));
  }, [l]);
  const b = a.useRef(!1);
  ft(() => (b.current = !0, () => {
    b.current = !1;
  }), []), ft(() => {
    if (M && (N.current = M), A && (_.current = A), M && A) {
      if (S.current)
        return S.current(M, A, w);
      w();
    }
  }, [M, A, w, S, K]);
  const k = a.useMemo(() => ({
    reference: N,
    floating: _,
    setReference: y,
    setFloating: R
  }), [y, R]), E = a.useMemo(() => ({
    reference: M,
    floating: A
  }), [M, A]), T = a.useMemo(() => {
    const O = {
      position: n,
      left: 0,
      top: 0
    };
    if (!E.floating)
      return O;
    const C = ln(E.floating, d.x), I = ln(E.floating, d.y);
    return c ? {
      ...O,
      transform: "translate(" + C + "px, " + I + "px)",
      ...Un(E.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: C,
      top: I
    };
  }, [n, c, E.floating, d.x, d.y]);
  return a.useMemo(() => ({
    ...d,
    update: w,
    refs: k,
    elements: E,
    floatingStyles: T
  }), [d, w, k, E, T]);
}
const Jr = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? un({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? un({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, Ao = (e, t) => ({
  ...Yr(e),
  options: [e, t]
}), So = (e, t) => ({
  ...zr(e),
  options: [e, t]
}), Lo = (e, t) => ({
  ...Ur(e),
  options: [e, t]
}), Do = (e, t) => ({
  ...Jr(e),
  options: [e, t]
});
function Fo(e) {
  const t = a.useRef(void 0), n = a.useCallback((r) => {
    const o = e.map((i) => {
      if (i != null) {
        if (typeof i == "function") {
          const s = i, c = s(r);
          return typeof c == "function" ? c : () => {
            s(null);
          };
        }
        return i.current = r, () => {
          i.current = null;
        };
      }
    });
    return () => {
      o.forEach((i) => i == null ? void 0 : i());
    };
  }, e);
  return a.useMemo(() => e.every((r) => r == null) ? null : (r) => {
    t.current && (t.current(), t.current = void 0), r != null && (t.current = n(r));
  }, e);
}
const Xn = {
  ...a
}, Qr = Xn.useInsertionEffect, Zr = Qr || ((e) => e());
function ie(e) {
  const t = a.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return Zr(() => {
    t.current = e;
  }), a.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
const Qt = "ArrowUp", ot = "ArrowDown", Ae = "ArrowLeft", Se = "ArrowRight";
function ut(e, t, n) {
  return Math.floor(e / t) !== n;
}
function Je(e, t) {
  return t < 0 || t >= e.current.length;
}
function At(e, t) {
  return fe(e, {
    disabledIndices: t
  });
}
function an(e, t) {
  return fe(e, {
    decrement: !0,
    startingIndex: e.current.length,
    disabledIndices: t
  });
}
function fe(e, t) {
  let {
    startingIndex: n = -1,
    decrement: r = !1,
    disabledIndices: o,
    amount: i = 1
  } = t === void 0 ? {} : t;
  const s = e.current;
  let c = n;
  do
    c += r ? -i : i;
  while (c >= 0 && c <= s.length - 1 && dt(s, c, o));
  return c;
}
function eo(e, t) {
  let {
    event: n,
    orientation: r,
    loop: o,
    rtl: i,
    cols: s,
    disabledIndices: c,
    minIndex: f,
    maxIndex: l,
    prevIndex: d,
    stopEvent: g = !1
  } = t, p = d;
  if (n.key === Qt) {
    if (g && le(n), d === -1)
      p = l;
    else if (p = fe(e, {
      startingIndex: p,
      amount: s,
      decrement: !0,
      disabledIndices: c
    }), o && (d - s < f || p < 0)) {
      const u = d % s, h = l % s, m = l - (h - u);
      h === u ? p = l : p = h > u ? m : m - s;
    }
    Je(e, p) && (p = d);
  }
  if (n.key === ot && (g && le(n), d === -1 ? p = f : (p = fe(e, {
    startingIndex: d,
    amount: s,
    disabledIndices: c
  }), o && d + s > l && (p = fe(e, {
    startingIndex: d % s - s,
    amount: s,
    disabledIndices: c
  }))), Je(e, p) && (p = d)), r === "both") {
    const u = He(d / s);
    n.key === (i ? Ae : Se) && (g && le(n), d % s !== s - 1 ? (p = fe(e, {
      startingIndex: d,
      disabledIndices: c
    }), o && ut(p, s, u) && (p = fe(e, {
      startingIndex: d - d % s - 1,
      disabledIndices: c
    }))) : o && (p = fe(e, {
      startingIndex: d - d % s - 1,
      disabledIndices: c
    })), ut(p, s, u) && (p = d)), n.key === (i ? Se : Ae) && (g && le(n), d % s !== 0 ? (p = fe(e, {
      startingIndex: d,
      decrement: !0,
      disabledIndices: c
    }), o && ut(p, s, u) && (p = fe(e, {
      startingIndex: d + (s - d % s),
      decrement: !0,
      disabledIndices: c
    }))) : o && (p = fe(e, {
      startingIndex: d + (s - d % s),
      decrement: !0,
      disabledIndices: c
    })), ut(p, s, u) && (p = d));
    const h = He(l / s) === u;
    Je(e, p) && (o && h ? p = n.key === (i ? Se : Ae) ? l : fe(e, {
      startingIndex: d - d % s - 1,
      disabledIndices: c
    }) : p = d);
  }
  return p;
}
function to(e, t, n) {
  const r = [];
  let o = 0;
  return e.forEach((i, s) => {
    let {
      width: c,
      height: f
    } = i;
    if (c > t && process.env.NODE_ENV !== "production")
      throw new Error("[Floating UI]: Invalid grid - item width at index " + s + " is greater than grid columns");
    let l = !1;
    for (n && (o = 0); !l; ) {
      const d = [];
      for (let g = 0; g < c; g++)
        for (let p = 0; p < f; p++)
          d.push(o + g + p * t);
      o % t + c <= t && d.every((g) => r[g] == null) ? (d.forEach((g) => {
        r[g] = s;
      }), l = !0) : o++;
    }
  }), [...r];
}
function no(e, t, n, r, o) {
  if (e === -1) return -1;
  const i = n.indexOf(e), s = t[e];
  switch (o) {
    case "tl":
      return i;
    case "tr":
      return s ? i + s.width - 1 : i;
    case "bl":
      return s ? i + (s.height - 1) * r : i;
    case "br":
      return n.lastIndexOf(e);
  }
}
function ro(e, t) {
  return t.flatMap((n, r) => e.includes(n) ? [r] : []);
}
function dt(e, t, n) {
  if (n)
    return n.includes(t);
  const r = e[t];
  return r == null || r.hasAttribute("disabled") || r.getAttribute("aria-disabled") === "true";
}
var G = typeof document < "u" ? Mn : kn;
function oo(e, t) {
  const n = e.compareDocumentPosition(t);
  return n & Node.DOCUMENT_POSITION_FOLLOWING || n & Node.DOCUMENT_POSITION_CONTAINED_BY ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING || n & Node.DOCUMENT_POSITION_CONTAINS ? 1 : 0;
}
const Gn = /* @__PURE__ */ a.createContext({
  register: () => {
  },
  unregister: () => {
  },
  map: /* @__PURE__ */ new Map(),
  elementsRef: {
    current: []
  }
});
function No(e) {
  const {
    children: t,
    elementsRef: n,
    labelsRef: r
  } = e, [o, i] = a.useState(() => /* @__PURE__ */ new Set()), s = a.useCallback((l) => {
    i((d) => new Set(d).add(l));
  }, []), c = a.useCallback((l) => {
    i((d) => {
      const g = new Set(d);
      return g.delete(l), g;
    });
  }, []), f = a.useMemo(() => {
    const l = /* @__PURE__ */ new Map();
    return Array.from(o.keys()).sort(oo).forEach((g, p) => {
      l.set(g, p);
    }), l;
  }, [o]);
  return /* @__PURE__ */ me(Gn.Provider, {
    value: a.useMemo(() => ({
      register: s,
      unregister: c,
      map: f,
      elementsRef: n,
      labelsRef: r
    }), [s, c, f, n, r]),
    children: t
  });
}
function _o(e) {
  e === void 0 && (e = {});
  const {
    label: t
  } = e, {
    register: n,
    unregister: r,
    map: o,
    elementsRef: i,
    labelsRef: s
  } = a.useContext(Gn), [c, f] = a.useState(null), l = a.useRef(null), d = a.useCallback((g) => {
    if (l.current = g, c !== null && (i.current[c] = g, s)) {
      var p;
      const u = t !== void 0;
      s.current[c] = u ? t : (p = g == null ? void 0 : g.textContent) != null ? p : null;
    }
  }, [c, i, s, t]);
  return G(() => {
    const g = l.current;
    if (g)
      return n(g), () => {
        r(g);
      };
  }, [n, r]), G(() => {
    const g = l.current ? o.get(l.current) : null;
    g != null && f(g);
  }, [o]), a.useMemo(() => ({
    ref: d,
    index: c ?? -1
  }), [c, d]);
}
let fn = !1, io = 0;
const dn = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + io++
);
function so() {
  const [e, t] = a.useState(() => fn ? dn() : void 0);
  return G(() => {
    e == null && t(dn());
  }, []), a.useEffect(() => {
    fn = !0;
  }, []), e;
}
const co = Xn.useId, it = co || so;
let et;
process.env.NODE_ENV !== "production" && (et = /* @__PURE__ */ new Set());
function mt() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const o = "Floating UI: " + n.join(" ");
  if (!((e = et) != null && e.has(o))) {
    var i;
    (i = et) == null || i.add(o), console.warn(o);
  }
}
function uo() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const o = "Floating UI: " + n.join(" ");
  if (!((e = et) != null && e.has(o))) {
    var i;
    (i = et) == null || i.add(o), console.error(o);
  }
}
const Vo = /* @__PURE__ */ a.forwardRef(function(t, n) {
  const {
    context: {
      placement: r,
      elements: {
        floating: o
      },
      middlewareData: {
        arrow: i,
        shift: s
      }
    },
    width: c = 14,
    height: f = 7,
    tipRadius: l = 0,
    strokeWidth: d = 0,
    staticOffset: g,
    stroke: p,
    d: u,
    style: {
      transform: h,
      ...m
    } = {},
    ...x
  } = t;
  process.env.NODE_ENV !== "production" && (n || mt("The `ref` prop is required for `FloatingArrow`."));
  const v = it(), [y, R] = a.useState(!1);
  if (G(() => {
    if (!o) return;
    be(o).direction === "rtl" && R(!0);
  }, [o]), !o)
    return null;
  const [M, A] = r.split("-"), N = M === "top" || M === "bottom";
  let _ = g;
  (N && s != null && s.x || !N && s != null && s.y) && (_ = null);
  const Y = d * 2, K = Y / 2, S = c / 2 * (l / -8 + 1), j = f / 2 * l / 4, P = !!u, w = _ && A === "end" ? "bottom" : "top";
  let b = _ && A === "end" ? "right" : "left";
  _ && y && (b = A === "end" ? "left" : "right");
  const k = (i == null ? void 0 : i.x) != null ? _ || i.x : "", E = (i == null ? void 0 : i.y) != null ? _ || i.y : "", T = u || "M0,0" + (" H" + c) + (" L" + (c - S) + "," + (f - j)) + (" Q" + c / 2 + "," + f + " " + S + "," + (f - j)) + " Z", O = {
    top: P ? "rotate(180deg)" : "",
    left: P ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: P ? "" : "rotate(180deg)",
    right: P ? "rotate(-90deg)" : "rotate(90deg)"
  }[M];
  return /* @__PURE__ */ jt("svg", {
    ...x,
    "aria-hidden": !0,
    ref: n,
    width: P ? c : c + Y,
    height: c,
    viewBox: "0 0 " + c + " " + (f > c ? f : c),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [b]: k,
      [w]: E,
      [M]: N || P ? "100%" : "calc(100% - " + Y / 2 + "px)",
      transform: [O, h].filter((C) => !!C).join(" "),
      ...m
    },
    children: [Y > 0 && /* @__PURE__ */ me("path", {
      clipPath: "url(#" + v + ")",
      fill: "none",
      stroke: p,
      strokeWidth: Y + (u ? 0 : 1),
      d: T
    }), /* @__PURE__ */ me("path", {
      stroke: Y && !u ? x.fill : "none",
      d: T
    }), /* @__PURE__ */ me("clipPath", {
      id: v,
      children: /* @__PURE__ */ me("rect", {
        x: -K,
        y: K * (P ? -1 : 1),
        width: c + Y,
        height: c
      })
    })]
  });
});
function Jn() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((o) => o(n));
    },
    on(t, n) {
      e.set(t, [...e.get(t) || [], n]);
    },
    off(t, n) {
      var r;
      e.set(t, ((r = e.get(t)) == null ? void 0 : r.filter((o) => o !== n)) || []);
    }
  };
}
const Qn = /* @__PURE__ */ a.createContext(null), Zn = /* @__PURE__ */ a.createContext(null), ze = () => {
  var e;
  return ((e = a.useContext(Qn)) == null ? void 0 : e.id) || null;
}, Ue = () => a.useContext(Zn);
function Ko(e) {
  const t = it(), n = Ue(), o = ze();
  return G(() => {
    if (!t) return;
    const i = {
      id: t,
      parentId: o
    };
    return n == null || n.addNode(i), () => {
      n == null || n.removeNode(i);
    };
  }, [n, t, o]), t;
}
function Wo(e) {
  const {
    children: t,
    id: n
  } = e, r = ze();
  return /* @__PURE__ */ me(Qn.Provider, {
    value: a.useMemo(() => ({
      id: n,
      parentId: r
    }), [n, r]),
    children: t
  });
}
function Bo(e) {
  const {
    children: t
  } = e, n = a.useRef([]), r = a.useCallback((s) => {
    n.current = [...n.current, s];
  }, []), o = a.useCallback((s) => {
    n.current = n.current.filter((c) => c !== s);
  }, []), i = a.useState(() => Jn())[0];
  return /* @__PURE__ */ me(Zn.Provider, {
    value: a.useMemo(() => ({
      nodesRef: n,
      addNode: r,
      removeNode: o,
      events: i
    }), [r, o, i]),
    children: t
  });
}
function We(e) {
  return "data-floating-ui-" + e;
}
function ge(e) {
  e.current !== -1 && (clearTimeout(e.current), e.current = -1);
}
function ve(e) {
  const t = ur(e);
  return G(() => {
    t.current = e;
  }), t;
}
const mn = /* @__PURE__ */ We("safe-polygon");
function St(e, t, n) {
  return n && !Ze(n) ? 0 : typeof e == "number" ? e : e == null ? void 0 : e[t];
}
function $o(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: o,
    events: i,
    elements: s
  } = e, {
    enabled: c = !0,
    delay: f = 0,
    handleClose: l = null,
    mouseOnly: d = !1,
    restMs: g = 0,
    move: p = !0
  } = t, u = Ue(), h = ze(), m = ve(l), x = ve(f), v = ve(n), y = a.useRef(), R = a.useRef(-1), M = a.useRef(), A = a.useRef(-1), N = a.useRef(!0), _ = a.useRef(!1), Y = a.useRef(() => {
  }), K = a.useRef(!1), S = a.useCallback(() => {
    var T;
    const O = (T = o.current.openEvent) == null ? void 0 : T.type;
    return (O == null ? void 0 : O.includes("mouse")) && O !== "mousedown";
  }, [o]);
  a.useEffect(() => {
    if (!c) return;
    function T(O) {
      let {
        open: C
      } = O;
      C || (ge(R), ge(A), N.current = !0, K.current = !1);
    }
    return i.on("openchange", T), () => {
      i.off("openchange", T);
    };
  }, [c, i]), a.useEffect(() => {
    if (!c || !m.current || !n) return;
    function T(C) {
      S() && r(!1, C, "hover");
    }
    const O = ae(s.floating).documentElement;
    return O.addEventListener("mouseleave", T), () => {
      O.removeEventListener("mouseleave", T);
    };
  }, [s.floating, n, r, c, m, S]);
  const j = a.useCallback(function(T, O, C) {
    O === void 0 && (O = !0), C === void 0 && (C = "hover");
    const I = St(x.current, "close", y.current);
    I && !M.current ? (ge(R), R.current = window.setTimeout(() => r(!1, T, C), I)) : O && (ge(R), r(!1, T, C));
  }, [x, r]), P = ie(() => {
    Y.current(), M.current = void 0;
  }), w = ie(() => {
    if (_.current) {
      const T = ae(s.floating).body;
      T.style.pointerEvents = "", T.removeAttribute(mn), _.current = !1;
    }
  }), b = ie(() => o.current.openEvent ? ["click", "mousedown"].includes(o.current.openEvent.type) : !1);
  a.useEffect(() => {
    if (!c) return;
    function T(D) {
      if (ge(R), N.current = !1, d && !Ze(y.current) || g > 0 && !St(x.current, "open"))
        return;
      const q = St(x.current, "open", y.current);
      q ? R.current = window.setTimeout(() => {
        v.current || r(!0, D, "hover");
      }, q) : n || r(!0, D, "hover");
    }
    function O(D) {
      if (b()) return;
      Y.current();
      const q = ae(s.floating);
      if (ge(A), K.current = !1, m.current && o.current.floatingContext) {
        n || ge(R), M.current = m.current({
          ...o.current.floatingContext,
          tree: u,
          x: D.clientX,
          y: D.clientY,
          onClose() {
            w(), P(), b() || j(D, !0, "safe-polygon");
          }
        });
        const ce = M.current;
        q.addEventListener("mousemove", ce), Y.current = () => {
          q.removeEventListener("mousemove", ce);
        };
        return;
      }
      (y.current === "touch" ? !ne(s.floating, D.relatedTarget) : !0) && j(D);
    }
    function C(D) {
      b() || o.current.floatingContext && (m.current == null || m.current({
        ...o.current.floatingContext,
        tree: u,
        x: D.clientX,
        y: D.clientY,
        onClose() {
          w(), P(), b() || j(D);
        }
      })(D));
    }
    if (X(s.domReference)) {
      var I;
      const D = s.domReference;
      return n && D.addEventListener("mouseleave", C), (I = s.floating) == null || I.addEventListener("mouseleave", C), p && D.addEventListener("mousemove", T, {
        once: !0
      }), D.addEventListener("mouseenter", T), D.addEventListener("mouseleave", O), () => {
        var q;
        n && D.removeEventListener("mouseleave", C), (q = s.floating) == null || q.removeEventListener("mouseleave", C), p && D.removeEventListener("mousemove", T), D.removeEventListener("mouseenter", T), D.removeEventListener("mouseleave", O);
      };
    }
  }, [s, c, e, d, g, p, j, P, w, r, n, v, u, x, m, o, b]), G(() => {
    var T;
    if (c && n && (T = m.current) != null && T.__options.blockPointerEvents && S()) {
      _.current = !0;
      const C = s.floating;
      if (X(s.domReference) && C) {
        var O;
        const I = ae(s.floating).body;
        I.setAttribute(mn, "");
        const D = s.domReference, q = u == null || (O = u.nodesRef.current.find((se) => se.id === h)) == null || (O = O.context) == null ? void 0 : O.elements.floating;
        return q && (q.style.pointerEvents = ""), I.style.pointerEvents = "none", D.style.pointerEvents = "auto", C.style.pointerEvents = "auto", () => {
          I.style.pointerEvents = "", D.style.pointerEvents = "", C.style.pointerEvents = "";
        };
      }
    }
  }, [c, n, h, s, u, m, S]), G(() => {
    n || (y.current = void 0, K.current = !1, P(), w());
  }, [n, P, w]), a.useEffect(() => () => {
    P(), ge(R), ge(A), w();
  }, [c, s.domReference, P, w]);
  const k = a.useMemo(() => {
    function T(O) {
      y.current = O.pointerType;
    }
    return {
      onPointerDown: T,
      onPointerEnter: T,
      onMouseMove(O) {
        const {
          nativeEvent: C
        } = O;
        function I() {
          !N.current && !v.current && r(!0, C, "hover");
        }
        d && !Ze(y.current) || n || g === 0 || K.current && O.movementX ** 2 + O.movementY ** 2 < 2 || (ge(A), y.current === "touch" ? I() : (K.current = !0, A.current = window.setTimeout(I, g)));
      }
    };
  }, [d, r, n, v, g]), E = a.useMemo(() => ({
    onMouseEnter() {
      ge(R);
    },
    onMouseLeave(T) {
      b() || j(T.nativeEvent, !1);
    }
  }), [j, b]);
  return a.useMemo(() => c ? {
    reference: k,
    floating: E
  } : {}, [c, k, E]);
}
let gn = 0;
function De(e, t) {
  t === void 0 && (t = {});
  const {
    preventScroll: n = !1,
    cancelPrevious: r = !0,
    sync: o = !1
  } = t;
  r && cancelAnimationFrame(gn);
  const i = () => e == null ? void 0 : e.focus({
    preventScroll: n
  });
  o ? i() : gn = requestAnimationFrame(i);
}
function pn(e, t) {
  var n;
  let r = [], o = (n = e.find((i) => i.id === t)) == null ? void 0 : n.parentId;
  for (; o; ) {
    const i = e.find((s) => s.id === o);
    o = i == null ? void 0 : i.parentId, i && (r = r.concat(i));
  }
  return r;
}
function _e(e, t) {
  let n = e.filter((o) => {
    var i;
    return o.parentId === t && ((i = o.context) == null ? void 0 : i.open);
  }), r = n;
  for (; r.length; )
    r = e.filter((o) => {
      var i;
      return (i = r) == null ? void 0 : i.some((s) => {
        var c;
        return o.parentId === s.id && ((c = o.context) == null ? void 0 : c.open);
      });
    }), n = n.concat(r);
  return n;
}
function lo(e, t) {
  let n, r = -1;
  function o(i, s) {
    s > r && (n = i, r = s), _e(e, i).forEach((f) => {
      o(f.id, s + 1);
    });
  }
  return o(t, 0), e.find((i) => i.id === n);
}
let $e = /* @__PURE__ */ new WeakMap(), lt = /* @__PURE__ */ new WeakSet(), at = {}, Lt = 0;
const ao = () => typeof HTMLElement < "u" && "inert" in HTMLElement.prototype, er = (e) => e && (e.host || er(e.parentNode)), fo = (e, t) => t.map((n) => {
  if (e.contains(n))
    return n;
  const r = er(n);
  return e.contains(r) ? r : null;
}).filter((n) => n != null);
function mo(e, t, n, r) {
  const o = "data-floating-ui-inert", i = r ? "inert" : n ? "aria-hidden" : null, s = fo(t, e), c = /* @__PURE__ */ new Set(), f = new Set(s), l = [];
  at[o] || (at[o] = /* @__PURE__ */ new WeakMap());
  const d = at[o];
  s.forEach(g), p(t), c.clear();
  function g(u) {
    !u || c.has(u) || (c.add(u), u.parentNode && g(u.parentNode));
  }
  function p(u) {
    !u || f.has(u) || [].forEach.call(u.children, (h) => {
      if (Le(h) !== "script")
        if (c.has(h))
          p(h);
        else {
          const m = i ? h.getAttribute(i) : null, x = m !== null && m !== "false", v = $e.get(h) || 0, y = i ? v + 1 : v, R = (d.get(h) || 0) + 1;
          $e.set(h, y), d.set(h, R), l.push(h), y === 1 && x && lt.add(h), R === 1 && h.setAttribute(o, ""), !x && i && h.setAttribute(i, "true");
        }
    });
  }
  return Lt++, () => {
    l.forEach((u) => {
      const h = $e.get(u) || 0, m = i ? h - 1 : h, x = (d.get(u) || 0) - 1;
      $e.set(u, m), d.set(u, x), m || (!lt.has(u) && i && u.removeAttribute(i), lt.delete(u)), x || u.removeAttribute(o);
    }), Lt--, Lt || ($e = /* @__PURE__ */ new WeakMap(), $e = /* @__PURE__ */ new WeakMap(), lt = /* @__PURE__ */ new WeakSet(), at = {});
  };
}
function hn(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = ae(e[0]).body;
  return mo(e.concat(Array.from(r.querySelectorAll("[aria-live]"))), r, t, n);
}
const Ct = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function tr(e, t) {
  const n = yt(e, Ct());
  t === "prev" && n.reverse();
  const r = n.indexOf(Re(ae(e)));
  return n.slice(r + 1)[0];
}
function nr() {
  return tr(document.body, "next");
}
function rr() {
  return tr(document.body, "prev");
}
function Qe(e, t) {
  const n = t || e.currentTarget, r = e.relatedTarget;
  return !r || !ne(n, r);
}
function go(e) {
  yt(e, Ct()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function vn(e) {
  e.querySelectorAll("[data-tabindex]").forEach((n) => {
    const r = n.dataset.tabindex;
    delete n.dataset.tabindex, r ? n.setAttribute("tabindex", r) : n.removeAttribute("tabindex");
  });
}
const It = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
}, bt = /* @__PURE__ */ a.forwardRef(function(t, n) {
  const [r, o] = a.useState();
  G(() => {
    _n() && o("button");
  }, []);
  const i = {
    ref: n,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: r,
    "aria-hidden": r ? void 0 : !0,
    [We("focus-guard")]: "",
    style: It
  };
  return /* @__PURE__ */ me("span", {
    ...t,
    ...i
  });
}), or = /* @__PURE__ */ a.createContext(null), bn = /* @__PURE__ */ We("portal");
function po(e) {
  e === void 0 && (e = {});
  const {
    id: t,
    root: n
  } = e, r = it(), o = ir(), [i, s] = a.useState(null), c = a.useRef(null);
  return G(() => () => {
    i == null || i.remove(), queueMicrotask(() => {
      c.current = null;
    });
  }, [i]), G(() => {
    if (!r || c.current) return;
    const f = t ? document.getElementById(t) : null;
    if (!f) return;
    const l = document.createElement("div");
    l.id = r, l.setAttribute(bn, ""), f.appendChild(l), c.current = l, s(l);
  }, [t, r]), G(() => {
    if (n === null || !r || c.current) return;
    let f = n || (o == null ? void 0 : o.portalNode);
    f && !X(f) && (f = f.current), f = f || document.body;
    let l = null;
    t && (l = document.createElement("div"), l.id = t, f.appendChild(l));
    const d = document.createElement("div");
    d.id = r, d.setAttribute(bn, ""), f = l || f, f.appendChild(d), c.current = d, s(d);
  }, [t, n, r, o]), i;
}
function Ho(e) {
  const {
    children: t,
    id: n,
    root: r,
    preserveTabOrder: o = !0
  } = e, i = po({
    id: n,
    root: r
  }), [s, c] = a.useState(null), f = a.useRef(null), l = a.useRef(null), d = a.useRef(null), g = a.useRef(null), p = s == null ? void 0 : s.modal, u = s == null ? void 0 : s.open, h = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!s && // Guards are only for non-modal focus management.
    !s.modal && // Don't render if unmount is transitioning.
    s.open && o && !!(r || i)
  );
  return a.useEffect(() => {
    if (!i || !o || p)
      return;
    function m(x) {
      i && Qe(x) && (x.type === "focusin" ? vn : go)(i);
    }
    return i.addEventListener("focusin", m, !0), i.addEventListener("focusout", m, !0), () => {
      i.removeEventListener("focusin", m, !0), i.removeEventListener("focusout", m, !0);
    };
  }, [i, o, p]), a.useEffect(() => {
    i && (u || vn(i));
  }, [u, i]), /* @__PURE__ */ jt(or.Provider, {
    value: a.useMemo(() => ({
      preserveTabOrder: o,
      beforeOutsideRef: f,
      afterOutsideRef: l,
      beforeInsideRef: d,
      afterInsideRef: g,
      portalNode: i,
      setFocusManagerState: c
    }), [o, i]),
    children: [h && i && /* @__PURE__ */ me(bt, {
      "data-type": "outside",
      ref: f,
      onFocus: (m) => {
        if (Qe(m, i)) {
          var x;
          (x = d.current) == null || x.focus();
        } else {
          const v = rr() || (s == null ? void 0 : s.domReference);
          v == null || v.focus();
        }
      }
    }), h && i && /* @__PURE__ */ me("span", {
      "aria-owns": i.id,
      style: It
    }), i && /* @__PURE__ */ An.createPortal(t, i), h && i && /* @__PURE__ */ me(bt, {
      "data-type": "outside",
      ref: l,
      onFocus: (m) => {
        if (Qe(m, i)) {
          var x;
          (x = g.current) == null || x.focus();
        } else {
          const v = nr() || (s == null ? void 0 : s.domReference);
          v == null || v.focus(), s != null && s.closeOnFocusOut && (s == null || s.onOpenChange(!1, m.nativeEvent, "focus-out"));
        }
      }
    })]
  });
}
const ir = () => a.useContext(or), $t = "data-floating-ui-focusable";
function Ht(e) {
  return e ? e.hasAttribute($t) ? e : e.querySelector("[" + $t + "]") || e : null;
}
function yn(e) {
  return a.useMemo(() => (t) => {
    e.forEach((n) => {
      n && (n.current = t);
    });
  }, e);
}
const ho = 20;
let Fe = [];
function vo(e) {
  Fe = Fe.filter((t) => t.isConnected), e && Le(e) !== "body" && (Fe.push(e), Fe.length > ho && (Fe = Fe.slice(-20)));
}
function wn() {
  return Fe.slice().reverse().find((e) => e.isConnected);
}
function bo(e) {
  const t = Ct();
  return ar(e, t) ? e : yt(e, t)[0] || e;
}
const yo = /* @__PURE__ */ a.forwardRef(function(t, n) {
  return /* @__PURE__ */ me("button", {
    ...t,
    type: "button",
    ref: n,
    tabIndex: -1,
    style: It
  });
});
function jo(e) {
  const {
    context: t,
    children: n,
    disabled: r = !1,
    order: o = ["content"],
    guards: i = !0,
    initialFocus: s = 0,
    returnFocus: c = !0,
    restoreFocus: f = !1,
    modal: l = !0,
    visuallyHiddenDismiss: d = !1,
    closeOnFocusOut: g = !0,
    outsideElementsInert: p = !1
  } = e, {
    open: u,
    onOpenChange: h,
    events: m,
    dataRef: x,
    elements: {
      domReference: v,
      floating: y
    }
  } = t, R = ie(() => {
    var F;
    return (F = x.current.floatingContext) == null ? void 0 : F.nodeId;
  }), M = typeof s == "number" && s < 0, A = Vn(v) && M, N = ao(), _ = N ? i : !0, Y = !_ || N && p, K = ve(o), S = ve(s), j = ve(c), P = Ue(), w = ir(), b = a.useRef(null), k = a.useRef(null), E = a.useRef(!1), T = a.useRef(!1), O = a.useRef(-1), C = w != null, I = Ht(y), D = ie(function(F) {
    return F === void 0 && (F = I), F ? yt(F, Ct()) : [];
  }), q = ie((F) => {
    const $ = D(F);
    return K.current.map((V) => v && V === "reference" ? v : I && V === "floating" ? I : $).filter(Boolean).flat();
  });
  a.useEffect(() => {
    if (r || !l) return;
    function F(V) {
      if (V.key === "Tab") {
        ne(I, Re(ae(I))) && D().length === 0 && !A && le(V);
        const H = q(), Q = Ie(V);
        K.current[0] === "reference" && Q === v && (le(V), V.shiftKey ? De(H[H.length - 1]) : De(H[1])), K.current[1] === "floating" && Q === I && V.shiftKey && (le(V), De(H[0]));
      }
    }
    const $ = ae(I);
    return $.addEventListener("keydown", F), () => {
      $.removeEventListener("keydown", F);
    };
  }, [r, v, I, l, K, A, D, q]), a.useEffect(() => {
    if (r || !y) return;
    function F($) {
      const V = Ie($), Q = D().indexOf(V);
      Q !== -1 && (O.current = Q);
    }
    return y.addEventListener("focusin", F), () => {
      y.removeEventListener("focusin", F);
    };
  }, [r, y, D]), a.useEffect(() => {
    if (r || !g) return;
    function F() {
      T.current = !0, setTimeout(() => {
        T.current = !1;
      });
    }
    function $(V) {
      const H = V.relatedTarget;
      queueMicrotask(() => {
        const Q = R(), te = !(ne(v, H) || ne(y, H) || ne(H, y) || ne(w == null ? void 0 : w.portalNode, H) || H != null && H.hasAttribute(We("focus-guard")) || P && (_e(P.nodesRef.current, Q).find((Z) => {
          var ee, he;
          return ne((ee = Z.context) == null ? void 0 : ee.elements.floating, H) || ne((he = Z.context) == null ? void 0 : he.elements.domReference, H);
        }) || pn(P.nodesRef.current, Q).find((Z) => {
          var ee, he, we;
          return [(ee = Z.context) == null ? void 0 : ee.elements.floating, Ht((he = Z.context) == null ? void 0 : he.elements.floating)].includes(H) || ((we = Z.context) == null ? void 0 : we.elements.domReference) === H;
        })));
        if (f && te && Re(ae(I)) === ae(I).body) {
          re(I) && I.focus();
          const Z = O.current, ee = D(), he = ee[Z] || ee[ee.length - 1] || I;
          re(he) && he.focus();
        }
        (A || !l) && H && te && !T.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        H !== wn() && (E.current = !0, h(!1, V, "focus-out"));
      });
    }
    if (y && re(v))
      return v.addEventListener("focusout", $), v.addEventListener("pointerdown", F), y.addEventListener("focusout", $), () => {
        v.removeEventListener("focusout", $), v.removeEventListener("pointerdown", F), y.removeEventListener("focusout", $);
      };
  }, [r, v, y, I, l, P, w, h, g, f, D, A, R]);
  const se = a.useRef(null), ce = a.useRef(null), ye = yn([se, w == null ? void 0 : w.beforeInsideRef]), oe = yn([ce, w == null ? void 0 : w.afterInsideRef]);
  a.useEffect(() => {
    var F;
    if (r || !y) return;
    const $ = Array.from((w == null || (F = w.portalNode) == null ? void 0 : F.querySelectorAll("[" + We("portal") + "]")) || []), V = P && !l ? pn(P == null ? void 0 : P.nodesRef.current, R()).map((te) => {
      var Z;
      return (Z = te.context) == null ? void 0 : Z.elements.floating;
    }) : [], H = [y, ...$, ...V, b.current, k.current, se.current, ce.current, w == null ? void 0 : w.beforeOutsideRef.current, w == null ? void 0 : w.afterOutsideRef.current, K.current.includes("reference") || A ? v : null].filter((te) => te != null), Q = l || A ? hn(H, !Y, Y) : hn(H);
    return () => {
      Q();
    };
  }, [r, v, y, l, K, w, A, _, Y, P, R]), G(() => {
    if (r || !re(I)) return;
    const F = ae(I), $ = Re(F);
    queueMicrotask(() => {
      const V = q(I), H = S.current, Q = (typeof H == "number" ? V[H] : H.current) || I, te = ne(I, $);
      !M && !te && u && De(Q, {
        preventScroll: Q === I
      });
    });
  }, [r, u, I, M, q, S]), G(() => {
    if (r || !I) return;
    let F = !1, $ = !1;
    const V = ae(I), H = Re(V);
    let te = x.current.openEvent;
    vo(H);
    function Z(we) {
      let {
        open: W,
        reason: U,
        event: L,
        nested: B
      } = we;
      if (W && (te = L), U === "escape-key" && ($ = !0), ["hover", "safe-polygon"].includes(U) && L.type === "mouseleave" && (E.current = !0), U === "outside-press")
        if (B)
          E.current = !1, F = !0;
        else if (Nn(L) || Yt(L))
          E.current = !1;
        else {
          let ue = !1;
          document.createElement("div").focus({
            get preventScroll() {
              return ue = !0, !1;
            }
          }), ue ? (E.current = !1, F = !0) : E.current = !0;
        }
    }
    m.on("openchange", Z);
    const ee = V.createElement("span");
    ee.setAttribute("tabindex", "-1"), ee.setAttribute("aria-hidden", "true"), Object.assign(ee.style, It), C && v && v.insertAdjacentElement("afterend", ee);
    function he() {
      return typeof j.current == "boolean" ? $ && v ? v : wn() || ee : j.current.current || ee;
    }
    return () => {
      m.off("openchange", Z);
      const we = Re(V), W = ne(y, we) || P && _e(P.nodesRef.current, R()).some((L) => {
        var B;
        return ne((B = L.context) == null ? void 0 : B.elements.floating, we);
      });
      (W || te && ["click", "mousedown"].includes(te.type)) && ($ = !0);
      const U = he();
      queueMicrotask(() => {
        const L = bo(U);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        j.current && !E.current && re(L) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(L !== we && we !== V.body) || W) && L.focus({
          preventScroll: F
        }), ee.remove();
      });
    };
  }, [r, y, I, j, x, m, P, C, v, R]), a.useEffect(() => {
    queueMicrotask(() => {
      E.current = !1;
    });
  }, [r]), G(() => {
    if (!r && w)
      return w.setFocusManagerState({
        modal: l,
        closeOnFocusOut: g,
        open: u,
        onOpenChange: h,
        domReference: v
      }), () => {
        w.setFocusManagerState(null);
      };
  }, [r, w, l, u, h, g, v]), G(() => {
    if (r || !I || typeof MutationObserver != "function" || M) return;
    const F = () => {
      const V = I.getAttribute("tabindex"), H = D(), Q = Re(ae(y)), te = H.indexOf(Q);
      te !== -1 && (O.current = te), K.current.includes("floating") || Q !== v && H.length === 0 ? V !== "0" && I.setAttribute("tabindex", "0") : V !== "-1" && I.setAttribute("tabindex", "-1");
    };
    F();
    const $ = new MutationObserver(F);
    return $.observe(I, {
      childList: !0,
      subtree: !0,
      attributes: !0
    }), () => {
      $.disconnect();
    };
  }, [r, y, I, v, K, D, M]);
  function J(F) {
    return r || !d || !l ? null : /* @__PURE__ */ me(yo, {
      ref: F === "start" ? b : k,
      onClick: ($) => h(!1, $.nativeEvent),
      children: typeof d == "string" ? d : "Dismiss"
    });
  }
  const z = !r && _ && (l ? !A : !0) && (C || l);
  return /* @__PURE__ */ jt(lr, {
    children: [z && /* @__PURE__ */ me(bt, {
      "data-type": "inside",
      ref: ye,
      onFocus: (F) => {
        if (l) {
          const V = q();
          De(o[0] === "reference" ? V[0] : V[V.length - 1]);
        } else if (w != null && w.preserveTabOrder && w.portalNode)
          if (E.current = !1, Qe(F, w.portalNode)) {
            const V = nr() || v;
            V == null || V.focus();
          } else {
            var $;
            ($ = w.beforeOutsideRef.current) == null || $.focus();
          }
      }
    }), !A && J("start"), n, J("end"), z && /* @__PURE__ */ me(bt, {
      "data-type": "inside",
      ref: oe,
      onFocus: (F) => {
        if (l)
          De(q()[0]);
        else if (w != null && w.preserveTabOrder && w.portalNode)
          if (g && (E.current = !0), Qe(F, w.portalNode)) {
            const V = rr() || v;
            V == null || V.focus();
          } else {
            var $;
            ($ = w.afterOutsideRef.current) == null || $.focus();
          }
      }
    })]
  });
}
function xn(e) {
  return re(e.target) && e.target.tagName === "BUTTON";
}
function Rn(e) {
  return zt(e);
}
function qo(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: o,
    elements: {
      domReference: i
    }
  } = e, {
    enabled: s = !0,
    event: c = "click",
    toggle: f = !0,
    ignoreMouse: l = !1,
    keyboardHandlers: d = !0,
    stickIfOpen: g = !0
  } = t, p = a.useRef(), u = a.useRef(!1), h = a.useMemo(() => ({
    onPointerDown(m) {
      p.current = m.pointerType;
    },
    onMouseDown(m) {
      const x = p.current;
      m.button === 0 && c !== "click" && (Ze(x, !0) && l || (n && f && (!(o.current.openEvent && g) || o.current.openEvent.type === "mousedown") ? r(!1, m.nativeEvent, "click") : (m.preventDefault(), r(!0, m.nativeEvent, "click"))));
    },
    onClick(m) {
      const x = p.current;
      if (c === "mousedown" && p.current) {
        p.current = void 0;
        return;
      }
      Ze(x, !0) && l || (n && f && (!(o.current.openEvent && g) || o.current.openEvent.type === "click") ? r(!1, m.nativeEvent, "click") : r(!0, m.nativeEvent, "click"));
    },
    onKeyDown(m) {
      p.current = void 0, !(m.defaultPrevented || !d || xn(m)) && (m.key === " " && !Rn(i) && (m.preventDefault(), u.current = !0), m.key === "Enter" && r(!(n && f), m.nativeEvent, "click"));
    },
    onKeyUp(m) {
      m.defaultPrevented || !d || xn(m) || Rn(i) || m.key === " " && u.current && (u.current = !1, r(!(n && f), m.nativeEvent, "click"));
    }
  }), [o, i, c, l, d, r, n, g, f]);
  return a.useMemo(() => s ? {
    reference: h
  } : {}, [s, h]);
}
const wo = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, xo = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, En = (e) => {
  var t, n;
  return {
    escapeKey: typeof e == "boolean" ? e : (t = e == null ? void 0 : e.escapeKey) != null ? t : !1,
    outsidePress: typeof e == "boolean" ? e : (n = e == null ? void 0 : e.outsidePress) != null ? n : !0
  };
};
function Yo(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    elements: o,
    dataRef: i
  } = e, {
    enabled: s = !0,
    escapeKey: c = !0,
    outsidePress: f = !0,
    outsidePressEvent: l = "pointerdown",
    referencePress: d = !1,
    referencePressEvent: g = "pointerdown",
    ancestorScroll: p = !1,
    bubbles: u,
    capture: h
  } = t, m = Ue(), x = ie(typeof f == "function" ? f : () => !1), v = typeof f == "function" ? x : f, y = a.useRef(!1), R = a.useRef(!1), {
    escapeKey: M,
    outsidePress: A
  } = En(u), {
    escapeKey: N,
    outsidePress: _
  } = En(h), Y = a.useRef(!1), K = ie((k) => {
    var E;
    if (!n || !s || !c || k.key !== "Escape" || Y.current)
      return;
    const T = (E = i.current.floatingContext) == null ? void 0 : E.nodeId, O = m ? _e(m.nodesRef.current, T) : [];
    if (!M && (k.stopPropagation(), O.length > 0)) {
      let C = !0;
      if (O.forEach((I) => {
        var D;
        if ((D = I.context) != null && D.open && !I.context.dataRef.current.__escapeKeyBubbles) {
          C = !1;
          return;
        }
      }), !C)
        return;
    }
    r(!1, pr(k) ? k.nativeEvent : k, "escape-key");
  }), S = ie((k) => {
    var E;
    const T = () => {
      var O;
      K(k), (O = Ie(k)) == null || O.removeEventListener("keydown", T);
    };
    (E = Ie(k)) == null || E.addEventListener("keydown", T);
  }), j = ie((k) => {
    var E;
    const T = y.current;
    y.current = !1;
    const O = R.current;
    if (R.current = !1, l === "click" && O || T || typeof v == "function" && !v(k))
      return;
    const C = Ie(k), I = "[" + We("inert") + "]", D = ae(o.floating).querySelectorAll(I);
    let q = X(C) ? C : null;
    for (; q && !Oe(q); ) {
      const oe = Te(q);
      if (Oe(oe) || !X(oe))
        break;
      q = oe;
    }
    if (D.length && X(C) && !hr(C) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !ne(C, o.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(D).every((oe) => !ne(q, oe)))
      return;
    if (re(C) && b) {
      const oe = Oe(C), J = be(C), z = /auto|scroll/, F = oe || z.test(J.overflowX), $ = oe || z.test(J.overflowY), V = F && C.clientWidth > 0 && C.scrollWidth > C.clientWidth, H = $ && C.clientHeight > 0 && C.scrollHeight > C.clientHeight, Q = J.direction === "rtl", te = H && (Q ? k.offsetX <= C.offsetWidth - C.clientWidth : k.offsetX > C.clientWidth), Z = V && k.offsetY > C.clientHeight;
      if (te || Z)
        return;
    }
    const se = (E = i.current.floatingContext) == null ? void 0 : E.nodeId, ce = m && _e(m.nodesRef.current, se).some((oe) => {
      var J;
      return Pt(k, (J = oe.context) == null ? void 0 : J.elements.floating);
    });
    if (Pt(k, o.floating) || Pt(k, o.domReference) || ce)
      return;
    const ye = m ? _e(m.nodesRef.current, se) : [];
    if (ye.length > 0) {
      let oe = !0;
      if (ye.forEach((J) => {
        var z;
        if ((z = J.context) != null && z.open && !J.context.dataRef.current.__outsidePressBubbles) {
          oe = !1;
          return;
        }
      }), !oe)
        return;
    }
    r(!1, k, "outside-press");
  }), P = ie((k) => {
    var E;
    const T = () => {
      var O;
      j(k), (O = Ie(k)) == null || O.removeEventListener(l, T);
    };
    (E = Ie(k)) == null || E.addEventListener(l, T);
  });
  a.useEffect(() => {
    if (!n || !s)
      return;
    i.current.__escapeKeyBubbles = M, i.current.__outsidePressBubbles = A;
    let k = -1;
    function E(D) {
      r(!1, D, "ancestor-scroll");
    }
    function T() {
      window.clearTimeout(k), Y.current = !0;
    }
    function O() {
      k = window.setTimeout(
        () => {
          Y.current = !1;
        },
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        Rt() ? 5 : 0
      );
    }
    const C = ae(o.floating);
    c && (C.addEventListener("keydown", N ? S : K, N), C.addEventListener("compositionstart", T), C.addEventListener("compositionend", O)), v && C.addEventListener(l, _ ? P : j, _);
    let I = [];
    return p && (X(o.domReference) && (I = ke(o.domReference)), X(o.floating) && (I = I.concat(ke(o.floating))), !X(o.reference) && o.reference && o.reference.contextElement && (I = I.concat(ke(o.reference.contextElement)))), I = I.filter((D) => {
      var q;
      return D !== ((q = C.defaultView) == null ? void 0 : q.visualViewport);
    }), I.forEach((D) => {
      D.addEventListener("scroll", E, {
        passive: !0
      });
    }), () => {
      c && (C.removeEventListener("keydown", N ? S : K, N), C.removeEventListener("compositionstart", T), C.removeEventListener("compositionend", O)), v && C.removeEventListener(l, _ ? P : j, _), I.forEach((D) => {
        D.removeEventListener("scroll", E);
      }), window.clearTimeout(k);
    };
  }, [i, o, c, v, l, n, r, p, s, M, A, K, N, S, j, _, P]), a.useEffect(() => {
    y.current = !1;
  }, [v, l]);
  const w = a.useMemo(() => ({
    onKeyDown: K,
    ...d && {
      [wo[g]]: (k) => {
        r(!1, k.nativeEvent, "reference-press");
      },
      ...g !== "click" && {
        onClick(k) {
          r(!1, k.nativeEvent, "reference-press");
        }
      }
    }
  }), [K, r, d, g]), b = a.useMemo(() => ({
    onKeyDown: K,
    onMouseDown() {
      R.current = !0;
    },
    onMouseUp() {
      R.current = !0;
    },
    [xo[l]]: () => {
      y.current = !0;
    }
  }), [K, l]);
  return a.useMemo(() => s ? {
    reference: w,
    floating: b
  } : {}, [s, w, b]);
}
function Ro(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: r
  } = e, o = it(), i = a.useRef({}), [s] = a.useState(() => Jn()), c = ze() != null;
  if (process.env.NODE_ENV !== "production") {
    const u = r.reference;
    u && !X(u) && uo("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [f, l] = a.useState(r.reference), d = ie((u, h, m) => {
    i.current.openEvent = u ? h : void 0, s.emit("openchange", {
      open: u,
      event: h,
      reason: m,
      nested: c
    }), n == null || n(u, h, m);
  }), g = a.useMemo(() => ({
    setPositionReference: l
  }), []), p = a.useMemo(() => ({
    reference: f || r.reference || null,
    floating: r.floating || null,
    domReference: r.reference
  }), [f, r.reference, r.floating]);
  return a.useMemo(() => ({
    dataRef: i,
    open: t,
    onOpenChange: d,
    elements: p,
    events: s,
    floatingId: o,
    refs: g
  }), [t, d, p, s, o, g]);
}
function zo(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, n = Ro({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), r = e.rootContext || n, o = r.elements, [i, s] = a.useState(null), [c, f] = a.useState(null), d = (o == null ? void 0 : o.domReference) || i, g = a.useRef(null), p = Ue();
  G(() => {
    d && (g.current = d);
  }, [d]);
  const u = Gr({
    ...e,
    elements: {
      ...o,
      ...c && {
        reference: c
      }
    }
  }), h = a.useCallback((R) => {
    const M = X(R) ? {
      getBoundingClientRect: () => R.getBoundingClientRect(),
      contextElement: R
    } : R;
    f(M), u.refs.setReference(M);
  }, [u.refs]), m = a.useCallback((R) => {
    (X(R) || R === null) && (g.current = R, s(R)), (X(u.refs.reference.current) || u.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    R !== null && !X(R)) && u.refs.setReference(R);
  }, [u.refs]), x = a.useMemo(() => ({
    ...u.refs,
    setReference: m,
    setPositionReference: h,
    domReference: g
  }), [u.refs, m, h]), v = a.useMemo(() => ({
    ...u.elements,
    domReference: d
  }), [u.elements, d]), y = a.useMemo(() => ({
    ...u,
    ...r,
    refs: x,
    elements: v,
    nodeId: t
  }), [u, x, v, t, r]);
  return G(() => {
    r.dataRef.current.floatingContext = y;
    const R = p == null ? void 0 : p.nodesRef.current.find((M) => M.id === t);
    R && (R.context = y);
  }), a.useMemo(() => ({
    ...u,
    context: y,
    refs: x,
    elements: v
  }), [u, x, v, y]);
}
function Uo(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    events: o,
    dataRef: i,
    elements: s
  } = e, {
    enabled: c = !0,
    visibleOnly: f = !0
  } = t, l = a.useRef(!1), d = a.useRef(-1), g = a.useRef(!0);
  a.useEffect(() => {
    if (!c) return;
    const u = pe(s.domReference);
    function h() {
      !n && re(s.domReference) && s.domReference === Re(ae(s.domReference)) && (l.current = !0);
    }
    function m() {
      g.current = !0;
    }
    return u.addEventListener("blur", h), u.addEventListener("keydown", m, !0), () => {
      u.removeEventListener("blur", h), u.removeEventListener("keydown", m, !0);
    };
  }, [s.domReference, n, c]), a.useEffect(() => {
    if (!c) return;
    function u(h) {
      let {
        reason: m
      } = h;
      (m === "reference-press" || m === "escape-key") && (l.current = !0);
    }
    return o.on("openchange", u), () => {
      o.off("openchange", u);
    };
  }, [o, c]), a.useEffect(() => () => {
    ge(d);
  }, []);
  const p = a.useMemo(() => ({
    onPointerDown(u) {
      Yt(u.nativeEvent) || (g.current = !1);
    },
    onMouseLeave() {
      l.current = !1;
    },
    onFocus(u) {
      if (l.current) return;
      const h = Ie(u.nativeEvent);
      if (f && X(h))
        try {
          if (_n() && mr()) throw Error();
          if (!h.matches(":focus-visible")) return;
        } catch {
          if (!g.current && !zt(h))
            return;
        }
      r(!0, u.nativeEvent, "focus");
    },
    onBlur(u) {
      l.current = !1;
      const h = u.relatedTarget, m = u.nativeEvent, x = X(h) && h.hasAttribute(We("focus-guard")) && h.getAttribute("data-type") === "outside";
      d.current = window.setTimeout(() => {
        var v;
        const y = Re(s.domReference ? s.domReference.ownerDocument : document);
        !h && y === s.domReference || ne((v = i.current.floatingContext) == null ? void 0 : v.refs.floating.current, y) || ne(s.domReference, y) || x || r(!1, m, "focus");
      });
    }
  }), [i, s.domReference, r, f]);
  return a.useMemo(() => c ? {
    reference: p
  } : {}, [c, p]);
}
const Cn = "active", In = "selected";
function Dt(e, t, n) {
  const r = /* @__PURE__ */ new Map(), o = n === "item";
  let i = e;
  if (o && e) {
    const {
      [Cn]: s,
      [In]: c,
      ...f
    } = e;
    i = f;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1,
      [$t]: ""
    },
    ...i,
    ...t.map((s) => {
      const c = s ? s[n] : null;
      return typeof c == "function" ? e ? c(e) : null : c;
    }).concat(e).reduce((s, c) => (c && Object.entries(c).forEach((f) => {
      let [l, d] = f;
      if (!(o && [Cn, In].includes(l)))
        if (l.indexOf("on") === 0) {
          if (r.has(l) || r.set(l, []), typeof d == "function") {
            var g;
            (g = r.get(l)) == null || g.push(d), s[l] = function() {
              for (var p, u = arguments.length, h = new Array(u), m = 0; m < u; m++)
                h[m] = arguments[m];
              return (p = r.get(l)) == null ? void 0 : p.map((x) => x(...h)).find((x) => x !== void 0);
            };
          }
        } else
          s[l] = d;
    }), s), {})
  };
}
function Xo(e) {
  e === void 0 && (e = []);
  const t = e.map((c) => c == null ? void 0 : c.reference), n = e.map((c) => c == null ? void 0 : c.floating), r = e.map((c) => c == null ? void 0 : c.item), o = a.useCallback(
    (c) => Dt(c, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), i = a.useCallback(
    (c) => Dt(c, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), s = a.useCallback(
    (c) => Dt(c, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return a.useMemo(() => ({
    getReferenceProps: o,
    getFloatingProps: i,
    getItemProps: s
  }), [o, i, s]);
}
const Eo = "Escape";
function Ot(e, t, n) {
  switch (e) {
    case "vertical":
      return t;
    case "horizontal":
      return n;
    default:
      return t || n;
  }
}
function Ft(e, t) {
  return Ot(t, e === Qt || e === ot, e === Ae || e === Se);
}
function Nt(e, t, n) {
  return Ot(t, e === ot, n ? e === Ae : e === Se) || e === "Enter" || e === " " || e === "";
}
function On(e, t, n) {
  return Ot(t, n ? e === Ae : e === Se, e === ot);
}
function Tn(e, t, n, r) {
  const o = n ? e === Se : e === Ae, i = e === Qt;
  return t === "both" || t === "horizontal" && r && r > 1 ? e === Eo : Ot(t, o, i);
}
function Go(e, t) {
  const {
    open: n,
    onOpenChange: r,
    elements: o
  } = e, {
    listRef: i,
    activeIndex: s,
    onNavigate: c = () => {
    },
    enabled: f = !0,
    selectedIndex: l = null,
    allowEscape: d = !1,
    loop: g = !1,
    nested: p = !1,
    rtl: u = !1,
    virtual: h = !1,
    focusItemOnOpen: m = "auto",
    focusItemOnHover: x = !0,
    openOnArrowKeyDown: v = !0,
    disabledIndices: y = void 0,
    orientation: R = "vertical",
    cols: M = 1,
    scrollItemIntoView: A = !0,
    virtualItemRef: N,
    itemSizes: _,
    dense: Y = !1
  } = t;
  process.env.NODE_ENV !== "production" && (d && (g || mt("`useListNavigation` looping must be enabled to allow escaping."), h || mt("`useListNavigation` must be virtual to allow escaping.")), R === "vertical" && M > 1 && mt("In grid list navigation mode (`cols` > 1), the `orientation` should", 'be either "horizontal" or "both".'));
  const K = Ht(o.floating), S = ve(K), j = ze(), P = Ue();
  G(() => {
    e.dataRef.current.orientation = R;
  }, [e, R]);
  const w = ie(() => {
    c(E.current === -1 ? null : E.current);
  }), b = Vn(o.domReference), k = a.useRef(m), E = a.useRef(l ?? -1), T = a.useRef(null), O = a.useRef(!0), C = a.useRef(w), I = a.useRef(!!o.floating), D = a.useRef(n), q = a.useRef(!1), se = a.useRef(!1), ce = ve(y), ye = ve(n), oe = ve(A), J = ve(l), [z, F] = a.useState(), [$, V] = a.useState(), H = ie(() => {
    function W(B) {
      h ? (F(B.id), P == null || P.events.emit("virtualfocus", B), N && (N.current = B)) : De(B, {
        sync: q.current,
        preventScroll: !0
      });
    }
    const U = i.current[E.current];
    U && W(U), (q.current ? (B) => B() : requestAnimationFrame)(() => {
      const B = i.current[E.current] || U;
      if (!B) return;
      U || W(B);
      const ue = oe.current;
      ue && te && (se.current || !O.current) && (B.scrollIntoView == null || B.scrollIntoView(typeof ue == "boolean" ? {
        block: "nearest",
        inline: "nearest"
      } : ue));
    });
  });
  G(() => {
    f && (n && o.floating ? k.current && l != null && (se.current = !0, E.current = l, w()) : I.current && (E.current = -1, C.current()));
  }, [f, n, o.floating, l, w]), G(() => {
    if (f && n && o.floating)
      if (s == null) {
        if (q.current = !1, J.current != null)
          return;
        if (I.current && (E.current = -1, H()), (!D.current || !I.current) && k.current && (T.current != null || k.current === !0 && T.current == null)) {
          let W = 0;
          const U = () => {
            i.current[0] == null ? (W < 2 && (W ? requestAnimationFrame : queueMicrotask)(U), W++) : (E.current = T.current == null || Nt(T.current, R, u) || p ? At(i, ce.current) : an(i, ce.current), T.current = null, w());
          };
          U();
        }
      } else Je(i, s) || (E.current = s, H(), se.current = !1);
  }, [f, n, o.floating, s, J, p, i, R, u, w, H, ce]), G(() => {
    var W;
    if (!f || o.floating || !P || h || !I.current)
      return;
    const U = P.nodesRef.current, L = (W = U.find((de) => de.id === j)) == null || (W = W.context) == null ? void 0 : W.elements.floating, B = Re(ae(o.floating)), ue = U.some((de) => de.context && ne(de.context.elements.floating, B));
    L && !ue && O.current && L.focus({
      preventScroll: !0
    });
  }, [f, o.floating, P, j, h]), G(() => {
    if (!f || !P || !h || j) return;
    function W(U) {
      V(U.id), N && (N.current = U);
    }
    return P.events.on("virtualfocus", W), () => {
      P.events.off("virtualfocus", W);
    };
  }, [f, P, h, j, N]), G(() => {
    C.current = w, D.current = n, I.current = !!o.floating;
  }), G(() => {
    n || (T.current = null);
  }, [n]);
  const Q = s != null, te = a.useMemo(() => {
    function W(L) {
      if (!n) return;
      const B = i.current.indexOf(L);
      B !== -1 && E.current !== B && (E.current = B, w());
    }
    return {
      onFocus(L) {
        let {
          currentTarget: B
        } = L;
        q.current = !0, W(B);
      },
      onClick: (L) => {
        let {
          currentTarget: B
        } = L;
        return B.focus({
          preventScroll: !0
        });
      },
      // Safari
      ...x && {
        onMouseMove(L) {
          let {
            currentTarget: B
          } = L;
          q.current = !0, se.current = !1, W(B);
        },
        onPointerLeave(L) {
          let {
            pointerType: B
          } = L;
          if (!(!O.current || B === "touch") && (q.current = !0, E.current = -1, w(), !h)) {
            var ue;
            (ue = S.current) == null || ue.focus({
              preventScroll: !0
            });
          }
        }
      }
    };
  }, [n, S, x, i, w, h]), Z = ie((W) => {
    if (O.current = !1, q.current = !0, W.which === 229 || !ye.current && W.currentTarget === S.current)
      return;
    if (p && Tn(W.key, R, u, M)) {
      le(W), r(!1, W.nativeEvent, "list-navigation"), re(o.domReference) && (h ? P == null || P.events.emit("virtualfocus", o.domReference) : o.domReference.focus());
      return;
    }
    const U = E.current, L = At(i, y), B = an(i, y);
    if (b || (W.key === "Home" && (le(W), E.current = L, w()), W.key === "End" && (le(W), E.current = B, w())), M > 1) {
      const ue = _ || Array.from({
        length: i.current.length
      }, () => ({
        width: 1,
        height: 1
      })), de = to(ue, M, Y), Tt = de.findIndex((xe) => xe != null && !dt(i.current, xe, y)), st = de.reduce((xe, Pe, Ge) => Pe != null && !dt(i.current, Pe, y) ? Ge : xe, -1), Xe = de[eo({
        current: de.map((xe) => xe != null ? i.current[xe] : null)
      }, {
        event: W,
        orientation: R,
        loop: g,
        rtl: u,
        cols: M,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: ro([...y || i.current.map((xe, Pe) => dt(i.current, Pe) ? Pe : void 0), void 0], de),
        minIndex: Tt,
        maxIndex: st,
        prevIndex: no(
          E.current > B ? L : E.current,
          ue,
          de,
          M,
          // use a corner matching the edge closest to the direction
          // we're moving in so we don't end up in the same item. Prefer
          // top/left over bottom/right.
          W.key === ot ? "bl" : W.key === (u ? Ae : Se) ? "tr" : "tl"
        ),
        stopEvent: !0
      })];
      if (Xe != null && (E.current = Xe, w()), R === "both")
        return;
    }
    if (Ft(W.key, R)) {
      if (le(W), n && !h && Re(W.currentTarget.ownerDocument) === W.currentTarget) {
        E.current = Nt(W.key, R, u) ? L : B, w();
        return;
      }
      Nt(W.key, R, u) ? g ? E.current = U >= B ? d && U !== i.current.length ? -1 : L : fe(i, {
        startingIndex: U,
        disabledIndices: y
      }) : E.current = Math.min(B, fe(i, {
        startingIndex: U,
        disabledIndices: y
      })) : g ? E.current = U <= L ? d && U !== -1 ? i.current.length : B : fe(i, {
        startingIndex: U,
        decrement: !0,
        disabledIndices: y
      }) : E.current = Math.max(L, fe(i, {
        startingIndex: U,
        decrement: !0,
        disabledIndices: y
      })), Je(i, E.current) && (E.current = -1), w();
    }
  }), ee = a.useMemo(() => h && n && Q && {
    "aria-activedescendant": $ || z
  }, [h, n, Q, $, z]), he = a.useMemo(() => ({
    "aria-orientation": R === "both" ? void 0 : R,
    ...b ? {} : ee,
    onKeyDown: Z,
    onPointerMove() {
      O.current = !0;
    }
  }), [ee, Z, R, b]), we = a.useMemo(() => {
    function W(L) {
      m === "auto" && Nn(L.nativeEvent) && (k.current = !0);
    }
    function U(L) {
      k.current = m, m === "auto" && Yt(L.nativeEvent) && (k.current = !0);
    }
    return {
      ...ee,
      onKeyDown(L) {
        var B;
        O.current = !1;
        const ue = L.key.startsWith("Arrow"), de = ["Home", "End"].includes(L.key), Tt = ue || de, st = P == null || (B = P.nodesRef.current.find((Be) => Be.id === j)) == null || (B = B.context) == null || (B = B.dataRef) == null ? void 0 : B.current.orientation, Xe = On(L.key, R, u), xe = Tn(L.key, R, u, M), Pe = On(L.key, st, u), Ge = Ft(L.key, R), sr = (p ? Pe : Ge) || L.key === "Enter" || L.key.trim() === "";
        if (h && n) {
          const Be = P == null ? void 0 : P.nodesRef.current.find((ct) => ct.parentId == null), Me = P && Be ? lo(P.nodesRef.current, Be.id) : null;
          if (Tt && Me && N) {
            const ct = new KeyboardEvent("keydown", {
              key: L.key,
              bubbles: !0
            });
            if (Xe || xe) {
              var Zt, en;
              const cr = ((Zt = Me.context) == null ? void 0 : Zt.elements.domReference) === L.currentTarget, nn = xe && !cr ? (en = Me.context) == null ? void 0 : en.elements.domReference : Xe ? i.current.find((rn) => (rn == null ? void 0 : rn.id) === z) : null;
              nn && (le(L), nn.dispatchEvent(ct), V(void 0));
            }
            if ((Ge || de) && Me.context && Me.context.open && Me.parentId && L.currentTarget !== Me.context.elements.domReference) {
              var tn;
              le(L), (tn = Me.context.elements.domReference) == null || tn.dispatchEvent(ct);
              return;
            }
          }
          return Z(L);
        }
        if (!(!n && !v && ue)) {
          if (sr) {
            const Be = Ft(L.key, st);
            T.current = p && Be ? null : L.key;
          }
          if (p) {
            Pe && (le(L), n ? (E.current = At(i, ce.current), w()) : r(!0, L.nativeEvent, "list-navigation"));
            return;
          }
          Ge && (l != null && (E.current = l), le(L), !n && v ? r(!0, L.nativeEvent, "list-navigation") : Z(L), n && w());
        }
      },
      onFocus() {
        n && !h && (E.current = -1, w());
      },
      onPointerDown: U,
      onPointerEnter: U,
      onMouseDown: W,
      onClick: W
    };
  }, [z, ee, M, Z, ce, m, i, p, w, r, n, v, R, j, u, l, P, h, N]);
  return a.useMemo(() => f ? {
    reference: we,
    floating: he,
    item: te
  } : {}, [f, we, he, te]);
}
const Co = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function Jo(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    open: r,
    floatingId: o
  } = e, {
    enabled: i = !0,
    role: s = "dialog"
  } = t, c = (n = Co.get(s)) != null ? n : s, f = it(), d = ze() != null, g = a.useMemo(() => c === "tooltip" || s === "label" ? {
    ["aria-" + (s === "label" ? "labelledby" : "describedby")]: r ? o : void 0
  } : {
    "aria-expanded": r ? "true" : "false",
    "aria-haspopup": c === "alertdialog" ? "dialog" : c,
    "aria-controls": r ? o : void 0,
    ...c === "listbox" && {
      role: "combobox"
    },
    ...c === "menu" && {
      id: f
    },
    ...c === "menu" && d && {
      role: "menuitem"
    },
    ...s === "select" && {
      "aria-autocomplete": "none"
    },
    ...s === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [c, o, d, r, f, s]), p = a.useMemo(() => {
    const h = {
      id: o,
      ...c && {
        role: c
      }
    };
    return c === "tooltip" || s === "label" ? h : {
      ...h,
      ...c === "menu" && {
        "aria-labelledby": f
      }
    };
  }, [c, o, f, s]), u = a.useCallback((h) => {
    let {
      active: m,
      selected: x
    } = h;
    const v = {
      role: "option",
      ...m && {
        id: o + "-option"
      }
    };
    switch (s) {
      case "select":
        return {
          ...v,
          "aria-selected": m && x
        };
      case "combobox":
        return {
          ...v,
          ...m && {
            "aria-selected": !0
          }
        };
    }
    return {};
  }, [o, s]);
  return a.useMemo(() => i ? {
    reference: g,
    floating: p,
    item: u
  } : {}, [i, g, p, u]);
}
function Qo(e, t) {
  var n;
  const {
    open: r,
    dataRef: o
  } = e, {
    listRef: i,
    activeIndex: s,
    onMatch: c,
    onTypingChange: f,
    enabled: l = !0,
    findMatch: d = null,
    resetMs: g = 750,
    ignoreKeys: p = [],
    selectedIndex: u = null
  } = t, h = a.useRef(-1), m = a.useRef(""), x = a.useRef((n = u ?? s) != null ? n : -1), v = a.useRef(null), y = ie(c), R = ie(f), M = ve(d), A = ve(p);
  G(() => {
    r && (ge(h), v.current = null, m.current = "");
  }, [r]), G(() => {
    if (r && m.current === "") {
      var S;
      x.current = (S = u ?? s) != null ? S : -1;
    }
  }, [r, u, s]);
  const N = ie((S) => {
    S ? o.current.typing || (o.current.typing = S, R(S)) : o.current.typing && (o.current.typing = S, R(S));
  }), _ = ie((S) => {
    function j(E, T, O) {
      const C = M.current ? M.current(T, O) : T.find((I) => (I == null ? void 0 : I.toLocaleLowerCase().indexOf(O.toLocaleLowerCase())) === 0);
      return C ? E.indexOf(C) : -1;
    }
    const P = i.current;
    if (m.current.length > 0 && m.current[0] !== " " && (j(P, P, m.current) === -1 ? N(!1) : S.key === " " && le(S)), P == null || A.current.includes(S.key) || // Character key.
    S.key.length !== 1 || // Modifier key.
    S.ctrlKey || S.metaKey || S.altKey)
      return;
    r && S.key !== " " && (le(S), N(!0)), P.every((E) => {
      var T, O;
      return E ? ((T = E[0]) == null ? void 0 : T.toLocaleLowerCase()) !== ((O = E[1]) == null ? void 0 : O.toLocaleLowerCase()) : !0;
    }) && m.current === S.key && (m.current = "", x.current = v.current), m.current += S.key, ge(h), h.current = window.setTimeout(() => {
      m.current = "", x.current = v.current, N(!1);
    }, g);
    const b = x.current, k = j(P, [...P.slice((b || 0) + 1), ...P.slice(0, (b || 0) + 1)], m.current);
    k !== -1 ? (y(k), v.current = k) : S.key !== " " && (m.current = "", N(!1));
  }), Y = a.useMemo(() => ({
    onKeyDown: _
  }), [_]), K = a.useMemo(() => ({
    onKeyDown: _,
    onKeyUp(S) {
      S.key === " " && N(!1);
    }
  }), [_, N]);
  return a.useMemo(() => l ? {
    reference: Y,
    floating: K
  } : {}, [l, Y, K]);
}
function Pn(e, t) {
  const [n, r] = e;
  let o = !1;
  const i = t.length;
  for (let s = 0, c = i - 1; s < i; c = s++) {
    const [f, l] = t[s] || [0, 0], [d, g] = t[c] || [0, 0];
    l >= r != g >= r && n <= (d - f) * (r - l) / (g - l) + f && (o = !o);
  }
  return o;
}
function Io(e, t) {
  return e[0] >= t.x && e[0] <= t.x + t.width && e[1] >= t.y && e[1] <= t.y + t.height;
}
function Zo(e) {
  e === void 0 && (e = {});
  const {
    buffer: t = 0.5,
    blockPointerEvents: n = !1,
    requireIntent: r = !0
  } = e;
  let o, i = !1, s = null, c = null, f = performance.now();
  function l(g, p) {
    const u = performance.now(), h = u - f;
    if (s === null || c === null || h === 0)
      return s = g, c = p, f = u, null;
    const m = g - s, x = p - c, y = Math.sqrt(m * m + x * x) / h;
    return s = g, c = p, f = u, y;
  }
  const d = (g) => {
    let {
      x: p,
      y: u,
      placement: h,
      elements: m,
      onClose: x,
      nodeId: v,
      tree: y
    } = g;
    return function(M) {
      function A() {
        clearTimeout(o), x();
      }
      if (clearTimeout(o), !m.domReference || !m.floating || h == null || p == null || u == null)
        return;
      const {
        clientX: N,
        clientY: _
      } = M, Y = [N, _], K = Ie(M), S = M.type === "mouseleave", j = ne(m.floating, K), P = ne(m.domReference, K), w = m.domReference.getBoundingClientRect(), b = m.floating.getBoundingClientRect(), k = h.split("-")[0], E = p > b.right - b.width / 2, T = u > b.bottom - b.height / 2, O = Io(Y, w), C = b.width > w.width, I = b.height > w.height, D = (C ? w : b).left, q = (C ? w : b).right, se = (I ? w : b).top, ce = (I ? w : b).bottom;
      if (j && (i = !0, !S))
        return;
      if (P && (i = !1), P && !S) {
        i = !0;
        return;
      }
      if (S && X(M.relatedTarget) && ne(m.floating, M.relatedTarget) || y && _e(y.nodesRef.current, v).some((J) => {
        let {
          context: z
        } = J;
        return z == null ? void 0 : z.open;
      }))
        return;
      if (k === "top" && u >= w.bottom - 1 || k === "bottom" && u <= w.top + 1 || k === "left" && p >= w.right - 1 || k === "right" && p <= w.left + 1)
        return A();
      let ye = [];
      switch (k) {
        case "top":
          ye = [[D, w.top + 1], [D, b.bottom - 1], [q, b.bottom - 1], [q, w.top + 1]];
          break;
        case "bottom":
          ye = [[D, b.top + 1], [D, w.bottom - 1], [q, w.bottom - 1], [q, b.top + 1]];
          break;
        case "left":
          ye = [[b.right - 1, ce], [b.right - 1, se], [w.left + 1, se], [w.left + 1, ce]];
          break;
        case "right":
          ye = [[w.right - 1, ce], [w.right - 1, se], [b.left + 1, se], [b.left + 1, ce]];
          break;
      }
      function oe(J) {
        let [z, F] = J;
        switch (k) {
          case "top": {
            const $ = [C ? z + t / 2 : E ? z + t * 4 : z - t * 4, F + t + 1], V = [C ? z - t / 2 : E ? z + t * 4 : z - t * 4, F + t + 1], H = [[b.left, E || C ? b.bottom - t : b.top], [b.right, E ? C ? b.bottom - t : b.top : b.bottom - t]];
            return [$, V, ...H];
          }
          case "bottom": {
            const $ = [C ? z + t / 2 : E ? z + t * 4 : z - t * 4, F - t], V = [C ? z - t / 2 : E ? z + t * 4 : z - t * 4, F - t], H = [[b.left, E || C ? b.top + t : b.bottom], [b.right, E ? C ? b.top + t : b.bottom : b.top + t]];
            return [$, V, ...H];
          }
          case "left": {
            const $ = [z + t + 1, I ? F + t / 2 : T ? F + t * 4 : F - t * 4], V = [z + t + 1, I ? F - t / 2 : T ? F + t * 4 : F - t * 4];
            return [...[[T || I ? b.right - t : b.left, b.top], [T ? I ? b.right - t : b.left : b.right - t, b.bottom]], $, V];
          }
          case "right": {
            const $ = [z - t, I ? F + t / 2 : T ? F + t * 4 : F - t * 4], V = [z - t, I ? F - t / 2 : T ? F + t * 4 : F - t * 4], H = [[T || I ? b.left + t : b.right, b.top], [T ? I ? b.left + t : b.right : b.left + t, b.bottom]];
            return [$, V, ...H];
          }
        }
      }
      if (!Pn([N, _], ye)) {
        if (i && !O)
          return A();
        if (!S && r) {
          const J = l(M.clientX, M.clientY);
          if (J !== null && J < 0.1)
            return A();
        }
        Pn([N, _], oe([p, u])) ? !i && r && (o = window.setTimeout(A, 40)) : A();
      }
    };
  };
  return d.__options = {
    blockPointerEvents: n
  }, d;
}
export {
  Wo as F,
  Ko as a,
  ze as b,
  _o as c,
  zo as d,
  $o as e,
  qo as f,
  Jo as g,
  Yo as h,
  Go as i,
  Qo as j,
  Xo as k,
  Fo as l,
  No as m,
  Ho as n,
  jo as o,
  Bo as p,
  ko as q,
  Ao as r,
  Zo as s,
  Lo as t,
  Ue as u,
  So as v,
  Uo as w,
  Do as x,
  Vo as y
};
